module.exports = __webpack_public_path__ + "static/banner-60bf07a5f3a9a4b0e1e774ac16e350eb.jpg";